module.exports = __webpack_public_path__ + "static/media/location.a32d56e9.svg";